module.exports = __webpack_public_path__ + "static/media/logo-image.366e0b41.png";